import { Chapter } from "../../lib/motion";
import { FAQS } from "../../data";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "../ui/accordion";

export default function FAQSection() {
  return (
    <section data-testid="faq" className="py-24 md:py-32 bg-verra-base">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <Chapter number="09" overline="FAQ" title="Answers before you ask." />
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-b border-verra-blue/10">
              <AccordionTrigger className="text-left font-display text-xl text-verra-blue hover:text-verra-green hover:no-underline py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-verra-blue/70 text-base leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
